<template>
    <div>
        <transition name="delay-fade"> <!-- transition for buttons row -->
            <div class="row button-row">
                <div class="col-sm-6 filter-check">
                    <input type="checkbox" id="display-as-received" v-bind:checked="display.as_received" v-on:change="onDisplayChanged('as_received', $event.target.checked)" v-show="false">
                    <label class="control-label cursor-pointer m-r-10" for="display-as-received">
                        <i  style="width:15px" class="fa fa-check-square-o" v-if="display.as_received"></i>
                        <i  style="width:15px" class="fa fa-square-o" v-else></i>
                        As Received (AR)
                    </label>
                    <input type="checkbox" id="display-dry-weight" v-bind:checked="display.dry_weight" v-on:change="onDisplayChanged('dry_weight', $event.target.checked)" v-show="false">
                    <label class="control-label cursor-pointer" for="display-dry-weight">
                        <i  style="width:15px" class="fa fa-check-square-o" v-if="display.dry_weight"></i>
                        <i  style="width:15px" class="fa fa-square-o" v-else></i>
                        Dry Weight (DW)
                    </label>
                </div>

                <div class="col-sm-6 pull-right text-right">
                    <button type="button"
                            class="btn btn-lg btn-default m-r-5"
                            data-toggle="modal"
                            data-target="#export-modal"
                            @click="showExportOptions"
                    >
                        <i class="fa fa-download"></i> Export Data
                    </button>

                    <button type="button" class="btn btn-lg btn-primary m-l-5" @click="goBackToReports">
                        <i class="fa fa-arrow-left"></i> Back To Reports
                    </button>
                </div>
            </div>
        </transition>
        <transition name="delay-fade"> <!-- transition for results grid table -->
            <div id="results-container">
                <div>
                    <div class="pull-right">
                        <grid-settings
                            :columns="columns"
                            :userColumnsOrder="userColumnsOrder"
                            :userDisplay="display"
                            @save="updateGridSettings">
                        </grid-settings>
                    </div>
                </div>
                <div id="results-body">
                    <div v-show="isRetrievingResults" id="results-loading">
                        <div>Loading...</div>
                    </div>
                    <div v-show="errorMessage && !isRetrievingResults" class="text-center" v-cloak>
                        <label class="header-label">
                            @{{ errorMessage }}
                        </label>
                    </div>
                    <dynamic-table
                        ref="resultsTable"
                        :columns="visible_columns"
                        :rows="rows"
                        :page="page"
                        :rows_per_page="rowsPerPage"
                        :sortable="true"
                        :anchorable="true"
                        :display_anchors="false"
                        :draggable="false"
                        :resize_columns="false"
                    ></dynamic-table>
                </div>

                <!-- Export Results Modal -->
                <div class="modal fade" id="export-modal" data-backdrop="static">
                    <div class="modal-dialog modal-sm" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                                <h4 class="modal-title">Download Result Data</h4>
                            </div>
                            <div class="modal-body">
                                <div class="p-25">
                                    <!-- Export Options -->
                                    <div>
                                        <div class="form-group fg-line">
                                            <label>Pages:</label>
                                            <select class="form-control" v-model="exportFileInfo.pages">
                                                <option value="all">All Pages</option>
                                                <option value="current">Current Page ({{ page }})</option>
                                            </select>
                                        </div>
                                        <div class="form-group fg-line">
                                            <label>File Format:</label>
                                            <select class="form-control" v-model="exportFileInfo.format">
                                                <option value="csv">csv</option>
                                                <option value="xlsx">xlsx</option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- Export Error -->
                                    <div v-show="exportStatus === 'error'" class="text-center">
                                        <div class="alert alert-danger">
                                            There was an error generating the file.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer" v-if="exportStatus !== 'generating'">
                                <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><span class="fa fa-times"></span> Close</button>
                                <button type="button" class="btn btn-lg btn-primary" data-dismiss="modal" @click="prepareAndExport"><span class="fa fa-plus"></span> Create File</button>
                            </div>
                        </div>
                    </div>
                </div>

                <form id="generate-results-export" action="/results/download" method="POST" target="generated_export_file">
                    <csrf-token></csrf-token>
                </form>

                <iframe name="generated_export_file" src="about::blank" style="display:none"></iframe>
                <div>
                    <div style="margin:10px 5px 20px">
                        <paginator :available_page_sizes="[25,50,100,150,200]"
                                   :initial_page_size="rowsPerPage"
                                   :number_of_items="visible_rows"
                                   :filtered_from="rows.length"
                                   @change="changePagination"
                        ></paginator>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="scss">
    @import 'resources/assets/sass/global_variables';
</style>

<script>
    import {mapState, mapGetters} from 'vuex';

    module.exports = {
        props: {
            is_active: Boolean
        },

        watch: {
            is_active(newValue) {
                if (newValue && this.updateGrid) {
                    this.getResults();
                    this.updateGrid = false;
                }
            },

            // If any of these values change, mark as dirty
            selectedForGridView() {
                this.updateGrid = true;
            }
        },

        computed: {
            ...mapState('documents', ['selectedSampleTypes']),

            ...mapGetters('documents', ['selectedForGridView']),

            visible_rows () {
                return _.has(this.$refs,['resultsTable','allRows'])
                    ? this.$refs.resultsTable.allRows.filter(row => !row.hidden).length
                    : this.rows.length
            },

            visible_columns () {
                return this.columns.filter(column => !column.hidden);
            },

            report_ids: function() {
                return this.selectedForGridView
                    .filter(function(row){ return row.id })
                    .map(function(row){ return row.id.label ? row.id.label : row.id.number })
            }
        },

        data: function() {
            return {
                /*
                The value of column.id will act as a key to properties in row objects
                */
                columns: [],
                rows: [],
                page: 1,
                rowsPerPage: 50,
                exportFileInfo: {pages: 'all', format: 'csv' },
                exportStatus: 'options',
                isRetrievingResults: false,
                errorMessage: '',
                results: {
                    raw: []
                },
                userColumnsOrder: [],
                is_retrieving_columns: false,
                display: {
                    as_received: true,
                    dry_weight: true
                },
                updateGrid: true
            }
        },

        methods: {
            onDisplayChanged(displayField, newValue) {
                this.$set(this.display, displayField, newValue);

                // Change hidden status of columns with the basis
                const basis = displayField === 'as_received' ? 'AR' :
                    displayField === 'dry_weight' ? 'DW' : '';

                // This shouldn't be possible, but still check to make sure we have a valid field change
                if (basis === '') {
                    return;
                }

                this.userColumnsOrder.forEach(column => {
                    if (column.basis === basis) {
                        column.hidden = !newValue;
                    }
                });

                this.columns.forEach(column => {
                    if (column.basis === basis) {
                        column.hidden = !newValue;
                    }
                });
            },
            changePagination: function (pageNumber, itemsPerPage) {
                this.page = pageNumber;
                this.rowsPerPage = itemsPerPage;
            },

            showExportOptions: function() {
                this.exportStatus = 'options';
            },

            prepareAndExport: function() {
                this.exportStatus = 'generating';
                let rows = [];

                if (this.exportFileInfo.pages === 'all') {
                    rows = this.$refs.resultsTable.allRows.filter(row => !row.hidden);
                }
                else if (this.exportFileInfo.pages === 'current') {
                    rows = this.$refs.resultsTable.displayRows;
                }

                // Get Header row
                const columns = this.$refs.resultsTable.columns.filter(col => !col.hidden);

                // Get results data
                const rowData = rows.map(row => columns.map(column => row[column.id]));

                // Combine header and results
                const tableData = [[...columns], ...rowData];

                // Submit data to server to create file for download
                const f = $("<input />").attr('type', 'hidden').attr('name', 'fileFormat').val(this.exportFileInfo.format);
                const t = $("<input />").attr('type','hidden').attr('name','table').val(JSON.stringify(tableData));
                let form = $('#generate-results-export');

                form.append(f);
                form.append(t);
                form.submit();

                $('#export-modal').modal('hide');
            },

            getResults () {
                this.isRetrievingResults = true;
                this.columns = [];
                this.rows = [];
                this.$http.post('/results/reports', {
                    report_ids: this.report_ids,
                    sample_types: this.selectedSampleTypes
                }).then((response) => {
                    if (response.data) {
                        this.results.raw = Object.keys(response.data).map((k) => response.data[k])
                        this.isRetrievingResults = false;
                        this.processResults();
                    }
                });
            },

            processResults () {
                if (this.results.raw) {
                    if (this.userColumnsOrder) {
                        // Loop our columns and put them in our saved order
                        this.userColumnsOrder.forEach((column) => {
                            this.addColumn(column.label, column.units, column.basis, column.color, column.stick, column.hidden);
                        });
                    }
                    this.rows = this.results.raw.map(sample_row => {
                        let row = [];

                        // Loop through the columns in the row
                        sample_row.forEach(column => {
                            // Find the column index for the existing column
                            let column_num = this.findColumnIndex(column.caption, column.basis, column.units);
                            if (column_num < 0) {
                                // Add a new column if it doesn't exist already
                                column_num = this.addColumn(column.caption, column.units, column.basis);
                            }
                            // Set the value
                            let value_details = {
                                caption: column.caption,
                                value: column.value,
                                units: column.units,
                                outlier: column.outlier,
                                color: this.columns[column_num].color,
                                basis: column.basis,
                                classes: ['color-' + this.columns[column_num].color]
                            };

                            if (column.outlier) {
                                value_details.classes.push('outlier');
                            }

                            // mark that this column has data, if the value is not null
                            if (column.value !== null) {
                                this.columns[column_num].hasData = true;
                            }

                            row[column_num] = value_details;
                        });
                        return row;
                    });
                    this.columns = this.columns.map(column => {
                        return Object.assign(column,{
                            title: column.label
                                + (column.basis ? ' ' + column.basis : '')
                                + (column.units ? ' ' + column.units : ''),
                            sort_method: this.getSortMethod(column)
                        })
                    });

                    // Update columnsOrder to 'match' what is now in the columns
                    this.userColumnsOrder = this.columns.map(column => {
                        const userColumn = this.userColumnsOrder.find(userColumn => {
                            return userColumn.label === column.label
                                && userColumn.basis === column.basis
                                && userColumn.units === column.units;
                        });

                        return {
                            label: column.label,
                            units: column.units,
                            basis: column.basis,
                            stick: userColumn ? userColumn.stick : false,
                            hidden: userColumn ? userColumn.hidden : false,
                            color: column.color
                        };
                    });
                }
            },

            getSortMethod (column) {
                if (column) {
                    if (column.label) {
                        const label = column.label.toLowerCase()
                        switch (label) {
                            case 'account':
                            case 'lab number':
                                return 'numeric'
                            case 'report number':
                                return 'mwl_report'
                        }
                        if (label.includes('date')) {
                            return 'date'
                        }
                    }
                    if (column.units) {
                        return 'numeric'
                    }
                }
                return null
            },

            addColumn (label, units, basis, color, stick, hidden) {
                if (typeof color === 'undefined') {
                    color = 0;
                }
                const new_column = {
                    label: label,
                    units: units,
                    basis: basis,
                    id: this.columns.length,
                    stick: stick ? stick : false,
                    color: color,
                    classes: ['color-' + color],
                    hidden: hidden ? hidden : false,
                    hasData: false
                };
                return this.columns.push(new_column) - 1;
            },

            findColumnIndex (label, basis, units) {
                return this.columns.findIndex(column => {
                    return column.label === label
                        && column.basis === basis
                        && column.units === units;
                });
            },

            // Update the column order
            updateColumnsOrder (columnsOrder) {
                this.rows = [];
                this.columns = [];
                this.userColumnsOrder = columnsOrder;
                this.processResults();
            },

            // Update the column order
            updateColumnsVisibility (columnsDisplay) {
                // TODO Figure out if I need to do vue set on this
                this.display.as_received = columnsDisplay.as_received;
                this.display.dry_weight = columnsDisplay.dry_weight;
            },

            updateGridSettings(columnsOrder, columnsDisplay) {
                this.updateColumnsVisibility(columnsDisplay);
                this.updateColumnsOrder(columnsOrder);
                this.saveUserPreferences();
            },

            goBackToReports() {
                this.$emit('go-back');
            },

            getUserPreferences() {
                this.is_retrieving_columns = true;
                this.$http.get('/user/preferences', {
                    params: {
                        keys: ['column_display', 'column_order']
                    }
                }).then(function (response) {
                    if (response.data) {
                        // Set the initial column order/color from the user preferences
                        if (response.data.preferences['column_order'] !== null && response.data.preferences['column_order'].length > 0) {
                            this.userColumnsOrder = response.data.preferences['column_order'];
                        }

                        // Load the column display from the user preferences
                        this.updateColumnsVisibility(response.data.preferences['column_display']);
                    }
                    this.is_retrieving_columns = false;
                });
            },

            saveUserPreferences() {
                this.$http.post('/user/preferences', {
                    preferences: [
                        {
                            'key': 'column_display',
                            'value': this.display
                        },
                        {
                            'key': 'column_order',
                            'value': this.userColumnsOrder
                        }
                    ]
                });
            }
        },
        mounted: function () {
            this.getUserPreferences();
        }
    }
</script>



// WEBPACK FOOTER //
// document-list-results-view.vue?236a4928